import React, { useEffect, useContext } from 'react';
import { logger } from '@fiverr-private/perseus';
import { I18n, I18nProvider } from '@fiverr-private/fiverr_context';
import GigCardListings from '@fiverr-private/gig_listings/src/entries/GigCardListings';
import tracker from '../../../service/tracker';
import localStorage from '../../../service/localStorage';
import { CollectionContext, AppContext } from '../../../store';
import ErrorBoundary from '../errors/error_boundary/ErrorBoundary';
import fiverrChoiceIcon from './fiverr-choice-icon.svg';
import TooltipGuide from './TooltipGuide';
import ModalityCardWrapper from './ModalityCardWrapper';
import { TYPE } from './constants';

import './styles.scss';

const getModalitiesContext = (type) => ({
    sourceComponent: type === TYPE.SERVICE ? 'choice_modalities_service' : 'choice_modalities_pricing',
    queryParameters: {
        fiverr_choice: 'true'
    }
});

const Modalities = ({ listing = {} }) => {
    const { collectProps } = useContext(CollectionContext);
    const { inDiscountTest, inLogoDesignDiscountTest } = useContext(AppContext);

    useEffect(() => {
        try {
            tracker.viewChoiceModalities();
        } catch (e) {
            logger.warn('Failed to report Fiverr Choice Modalities to MixPanel', e);
        }
    }, []);

    const modalitiesListings = { ...listing, context: { ...listing.context, ...getModalitiesContext(listing.choiceModalities.type) } };
    const {
        type,
        buckets
    } = modalitiesListings.choiceModalities;

    const gigs = buckets.map(({ gig }) => gig);
    const gigToBucket = buckets.reduce((res, { gig, ...rest }, index) => {
        res[gig.gigId] = {
            bucketNumber: index + 1,
            ...rest
        };
        return res;
    }, {});

    const CardWrapper = (props) => <ModalityCardWrapper gigToBucketMap={gigToBucket} type={type} {...props}/>;

    return (
        <ErrorBoundary>
            <div className="modalities">
                <header className="modalities-header">
                    <I18nProvider>
                        {({ i18n }) => (
                            <TooltipGuide className="modalities-popup"
                                storageKey={localStorage.KEYS.FIVERR_CHOICE_MODALITIES_TOOLTIP}
                                content={i18n.t('search_perseus.choice_modalities.tooltip')}>
                                <img src={fiverrChoiceIcon} alt="Fiverr Choice"/>
                            </TooltipGuide>
                        )}
                    </I18nProvider>
                    <h3>
                        <I18n k="search_perseus.choice_modalities.title"/>
                    </h3>
                </header>
                <GigCardListings {...modalitiesListings}
                    gigs={gigs}
                    collectProps={collectProps}
                    Wrapper={CardWrapper}
                    inDiscountTest={inDiscountTest}
                    inLogoDesignDiscountTest={inLogoDesignDiscountTest}/>
            </div>
        </ErrorBoundary>
    );
};

export default Modalities;
